import api from '@/api'
import request from '@/utils/request'
import store from '..'
/**
 * @description 异常捕获的状态拦截，请勿修改
 */
const state = () => ({
  errorLogs: [],
})
const getters = {
  errorLogs: (state) => state.errorLogs,
}
const mutations = {
  addErrorLog(state, errorLog) {
    state.errorLogs.push(errorLog)
  },
  clearErrorLog: (state) => {
    state.errorLogs.splice(0)
  },
}
const actions = {
  addErrorLog({ commit }, errorLog) {
    commit('addErrorLog', errorLog)
  },
  clearErrorLog({ commit }) {
    commit('clearErrorLog')
  },
  LogAppend(context, data) {
    try {
      setTimeout(async () => {
        if (data.config && data.config.url.indexOf('GetTenantByCode') != -1)
          return
        const obj = {
          url: data.url,
          msg: JSON.parse(JSON.stringify(data.message)),
          userAgent: navigator.userAgent,
          tenant: await store.getters['user/getTenant'],
          userInfo: store.getters['user/getUserInfo'],
        }
        if (data.config) {
          obj.request = {
            url: data.config.url,
            data: data.config.data,
          }
        }
        if (data.data) {
          obj.response = data.data
        }
        const params = {
          level: data.level,
          message: JSON.stringify(obj),
        }
        return request({
          url: api.LogAppend,
          method: 'POST',
          data: params,
        })
      }, 1000)
    } catch (error) {
      console.log(error)
    }
  },
  LogQuery(context, params) {
    return request({
      url: api.LogQuery,
      method: 'GET',
      params,
    })
  },
}
export default { state, getters, mutations, actions }
